import type { ButtonHTMLAttributes } from "react";

export default function SecondaryButton({
    className = "",
    disabled,
    children,
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            disabled={disabled}
            className={
                "inline-flex min-h-touch items-center justify-center gap-2 rounded-lg border " +
                "border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 shadow-sm " +
                "transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500 " +
                "focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 " +
                "dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 " +
                className
            }
        >
            {children}
        </button>
    );
}
